import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["list"];
  static values = {
    date: String,
    directorId: String,
  };

  initialize() {
    this.sortableInstances = [];
  }

  connect() {
    this.initSortables();
    this.setupMutationObserver();
  }

  initSortables() {
    const sortableInstance = this.listTargets.forEach((list) => {
      Sortable.create(list, {
        filter: ".drag-disabled",
        group: {
          name: "reps",
          put: (to) => this.canMoveTo(to.el),
        },
        animation: 150,
        onAdd: (event) => {
          this.handleAccordion(event, list);
          this.handleUpdate(event);
        },
      });
    });

    this.sortableInstances.push(sortableInstance);
  }

  canMoveTo(targetList) {
    if (!targetList.closest("[data-sdr-van-id]")?.dataset.sdrVanId) return true;

    return targetList.children.length < 1;
  }

  handleAccordion(event, list) {
    list
      .querySelector(".drop-destination")
      ?.appendChild(list.removeChild(event.item));
  }

  handleUpdate(event) {
    const repId = event.item.dataset.sdrRepId;
    const workingTypeId = event.item.closest("[data-sdr-working-type-id]")
      ?.dataset.sdrWorkingTypeId;
    const vanId = event.item.closest("[data-sdr-van-id]")?.dataset.sdrVanId;
    const previousVanId =
      event.from.closest("[data-sdr-van-id]")?.dataset.sdrVanId;
    const seatNumber = event.item.closest("[data-van-seat-number]")?.dataset
      .vanSeatNumber;

    fetch(
      `/sdr_directors/${this.directorIdValue}/sdr_assignments/update_attendance`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
            .content,
        },
        body: JSON.stringify({
          sdr_assignment: {
            rep_id: repId,
            working_type_id: workingTypeId,
            van_id: vanId,
            previous_van_id: previousVanId,
            seat_number: seatNumber,
            date: this.dateValue,
          },
        }),
      }
    )
      .then((response) => response.text())
      .then((html) => {
        Turbo.session.renderStreamMessage(html);
        this.updateCounts(event.from, event.to);
      });
  }

  updateCounts(fromList, toList) {
    const fromListType = fromList.dataset.sdrAssignmentDragList;
    const toListType = toList.dataset.sdrAssignmentDragList;
    const fromCountSpan = document.querySelector(
      `[data-sdr-assign-list-count="${fromListType}_${this.directorIdValue}"]`
    );
    const toCountSpan = document.querySelector(
      `[data-sdr-assign-list-count="${toListType}_${this.directorIdValue}"]`
    );

    if (fromCountSpan) {
      const fromCount = parseInt(fromCountSpan.textContent, 10);
      fromCountSpan.textContent = Math.max(0, fromCount - 1);
    }

    if (toCountSpan) {
      const toCount = parseInt(toCountSpan.textContent, 10);
      toCountSpan.textContent = toCount + 1;
    }
  }

  reloadVanAssignments() {
    const vanFrame = document.querySelector("#van_assignments");
    if (vanFrame) {
      vanFrame.reload();
    }
  }

  reinitializeSortables() {
    this.destroySortables();
    setTimeout(() => {
      this.initSortables();
    }, 100);
  }

  destroySortables() {
    this.sortableInstances.forEach((instance) => {
      if (instance) {
        instance.destroy();
      }
    });
    this.sortableInstances = [];
  }

  setupMutationObserver() {
    this.mutationObserver = new MutationObserver((mutations) => {
      const hasNewDropzones = mutations.some((mutation) => {
        if (mutation.type !== "childList") return false;
        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            return (
              node.querySelector?.("[data-sdr-assignment-drag-target]") ||
              node.dataset?.sdrAssignmentDragTarget
            );
          }
          return false;
        });
      });

      if (hasNewDropzones) {
        clearTimeout(this.reinitializeTimeout);
        this.reinitializeTimeout = setTimeout(() => {
          this.reinitializeSortables();
        }, 150);
      }
    });

    this.mutationObserver.observe(this.element, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });
  }
}
